import React from "react";
import { useTranslation } from "react-i18next";
import { PiPlusBold } from "react-icons/pi";
import { Badge, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { severityColors } from "@constants/colors";

import { PatientAllergy } from "@customTypes/patient";

import { AddAllergyModal } from "../AddAllergyModal";
import { FullAllergiesModal } from "../FullAllergiesModal";

import { StyledAllergyCard } from "./AllergyCard.styled";


interface AllergyCardProps {
  allergies?: PatientAllergy[];
}

const MAX_ALLERGIES_DISPLAYED = 5;
export const AllergyCard = ({ allergies = [] }: AllergyCardProps) => {
  const { t } = useTranslation();
  const [addAllergyOpened, { open: addAllergyOpen, close: addAllergyClose }] =
    useDisclosure(false);
  const [
    viewAllergiesOpened,
    { open: viewAllergiesOpen, close: viewAllergiesClose },
  ] = useDisclosure(false);

  return (
    <StyledAllergyCard>
      <AddAllergyModal opened={addAllergyOpened} close={addAllergyClose} />
      <div className="card-header">
        <p className="heading">{t("allergies")}</p>
        <button onClick={addAllergyOpen} type="button">
          <PiPlusBold className="plus-icon" />
        </button>
      </div>
      <div className="body">
        {allergies?.length > 0 ? (
          <>
            <div className="tags-wrapper">
              {allergies
                .slice(0, MAX_ALLERGIES_DISPLAYED)
                .map(({ allergy, severity }, index) => (
                  <React.Fragment key={index}>
                    {/* <span className={`severity-${severity}`} key={index}>
                        {allergy}
                      </span> */}
                    <Badge
                      size="lg"
                      fz={13}
                      h="1.5rem"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }>
                      {allergy}
                    </Badge>
                    {index === MAX_ALLERGIES_DISPLAYED - 1 &&
                    allergies.length - MAX_ALLERGIES_DISPLAYED > 0 ? (
                      <span className={"allergies-left"}>
                        +
                        {t("plus-x-more", {
                          amount: allergies.length - MAX_ALLERGIES_DISPLAYED,
                        })}
                      </span>
                    ) : null}
                  </React.Fragment>
                ))}
            </div>
          </>
        ) : (
          <p className="empty-label">{t("empty-allergies")}</p>
        )}
      </div>
      <div className="card-footer">
        <FullAllergiesModal
          opened={viewAllergiesOpened}
          close={viewAllergiesClose}
          allergies={allergies}
        />
        <Button
          type="button"
          onClick={viewAllergiesOpen}
          variant="transparent"
          size="compact-sm"
          disabled={allergies.length === 0}>
          {t("view-allergies")}
        </Button>
      </div>
    </StyledAllergyCard>
  );
};
